<template>
  <section>
    <div class="is-clearfix">
      <div class="is-pulled-left">
        <p class="is-size-7 is-uppercase has-text-grey has-text-weight-bold pt-1">{{ filterTitle }}</p>
      </div>
      <div class="is-pulled-right">
        <p class="is-size-6 has-text-grey-dark is-clickable pb-1" @click="$emit('closeFilterBox');">x</p>
      </div>
    </div>
    <hr class="p-0 m-0 mb-3 is-clearfix">
  </section>
</template>

<script>
export default {
  name: "FilterBoxHeader",
  data() {
    return {
    }
  },
  props:{
    filterName:{},
  },
  computed: {
    filterTitle() {
      return this.filterName;
    }
  },
}
</script>

<style scoped>

</style>